(() => {
  if (window.sapHomeEssentialsLoaded) return;
  window.sapHomeEssentialsLoaded = true;
  const setups = new Map();
  const ends = row => {
    const root = row.closest('[data-home-essentials]');
    const max = row.scrollWidth - row.clientWidth;
    root.querySelector('[data-essentials-step="-1"]').setAttribute('aria-disabled', String(row.scrollLeft < 8));
    root.querySelector('[data-essentials-step="1"]').setAttribute('aria-disabled', String(row.scrollLeft > max - 8));
    root.classList.toggle('is-still',max < 8);
  };
  const init = root => root.querySelectorAll('[data-essentials-row]').forEach(row => {
    if(setups.has(row)) return;
    const resize = new ResizeObserver(() => ends(row));resize.observe(row);
    setups.set(row,resize);ends(row);
  });
  init(document);
  document.addEventListener('scroll',event => { if(event.target.matches?.('[data-essentials-row]')) ends(event.target); },true);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => setups.forEach((observer,row) => { if(event.target.contains(row)){observer.disconnect();setups.delete(row);} }));
  document.addEventListener('click',event => {
    const flip = event.target.closest('[data-card-flip]');
    if (flip) {
      const turned = flip.getAttribute('aria-pressed') !== 'true';
      flip.setAttribute('aria-pressed',String(turned));
      const photo = flip.closest('[data-card-photo]');
      photo.toggleAttribute('data-turned',turned);
      photo.querySelector('[data-card-back]').setAttribute('aria-hidden',String(!turned));
    }
    const step = event.target.closest('[data-essentials-step]');
    if (step && step.getAttribute('aria-disabled') === 'true') return;
    if (step) {
      const row = step.closest('[data-home-essentials]').querySelector('[data-essentials-row]');
      const card = row.firstElementChild;
      const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth * .8;
      row.scrollBy({left: Number(step.dataset.essentialsStep) * Math.max(distance,row.clientWidth * .5),behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
})();
